import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["items", "selectedKey", "setField"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
import React from "react";
import MuiAutocomplete from "../value/MuiAutocomplete";
var itemsToListValues = function itemsToListValues(items) {
  var level = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  return items.map(function (item) {
    var items = item.items,
      path = item.path,
      label = item.label,
      disabled = item.disabled,
      grouplabel = item.grouplabel,
      matchesType = item.matchesType;
    var prefix = "\xA0\xA0".repeat(level);
    if (items) {
      return itemsToListValues(items, level + 1);
    } else {
      return {
        title: label,
        renderTitle: matchesType ? /*#__PURE__*/React.createElement("b", null, prefix + label) : prefix + label,
        value: path,
        disabled: disabled,
        groupTitle: level > 0 ? prefix + grouplabel : null
      };
    }
  }).flat(Infinity);
};
var groupBy = function groupBy(option) {
  return option === null || option === void 0 ? void 0 : option.groupTitle;
};
var fixGroupBy = function fixGroupBy(listValues) {
  var newValues = [];
  var _iterator = _createForOfIteratorHelper(listValues),
    _step;
  try {
    var _loop = function _loop() {
      var lv = _step.value;
      var i = newValues.findLastIndex(function (lv1) {
        return groupBy(lv1) === groupBy(lv);
      });
      if (i != -1) {
        newValues.splice(i + 1, 0, lv);
      } else {
        newValues.push(lv);
      }
    };
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      _loop();
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return newValues;
};
var filterOptionsConfig = {
  stringify: function stringify(option) {
    var keysForFilter = ["title", "value", "grouplabel", "label"];
    var valueForFilter = keysForFilter.map(function (k) {
      return typeof option[k] == "string" ? option[k] : "";
    }).join("\0");
    return valueForFilter;
  }
};
var fieldAdapter = function fieldAdapter(_ref) {
  var items = _ref.items,
    selectedKey = _ref.selectedKey,
    setField = _ref.setField,
    rest = _objectWithoutProperties(_ref, _excluded);
  var listValues = itemsToListValues(items);
  var fixedListValues = fixGroupBy(listValues);
  var value = selectedKey;
  var setValue = function setValue(value, _asyncValues) {
    if (!value) return undefined;
    return setField(value);
  };
  return _objectSpread(_objectSpread({}, rest), {}, {
    listValues: fixedListValues,
    setValue: setValue,
    groupBy: groupBy,
    filterOptionsConfig: filterOptionsConfig,
    allowCustomValues: false,
    multiple: false,
    value: value
  });
};
export default (function (props) {
  return /*#__PURE__*/React.createElement(MuiAutocomplete, fieldAdapter(props));
});